import { combineReducers } from 'redux';

import gameInfo from './gameInfoReducer';
import levelPopup from './levelPopupReducer';
import loading from './loadingReducer';

export default combineReducers({
    gameInfo,
    levelPopup,
    loading
});
